/**
 * The Chase queue's Age column: pure, so it is testable without a DOM or the
 * Firebase build constants (same split as `filters.ts`).
 *
 * Ed, 2026-09-30: cases mint at shift end, so a row reads "ended 2h 50m ago ·
 * due in 21h 10m" until the 24-hour write-up deadline, then "overdue 3h 5m".
 * Minutes under a day, so the two halves visibly add up to the deadline and
 * nobody reads a rounding gap as something missed. The ledger's dates are
 * naive UK wall-clock ISO strings (OneTouch convention); Date parsing treats
 * them as local, which is the same wall clock.
 */

/** "1d 3h" at a day or more; "2h 50m" / "50m" under a day. */
export function spanOf(ms: number): string {
  const abs = Math.abs(ms);
  const d = Math.floor(abs / 86_400_000);
  const h = Math.floor((abs % 86_400_000) / 3_600_000);
  const m = Math.floor((abs % 3_600_000) / 60_000);
  if (d > 0) return `${d}d ${h}h`;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function ageLabel(
  dueEnd: string | null,
  shiftEnd: string | null,
  now: number = Date.now(),
): { text: string; overdue: boolean } {
  if (!dueEnd) return { text: "—", overdue: false };
  const diff = now - new Date(dueEnd).getTime();
  if (diff >= 0) return { text: `overdue ${spanOf(diff)}`, overdue: true };
  const ended = shiftEnd ? `ended ${spanOf(now - new Date(shiftEnd).getTime())} ago · ` : "";
  return { text: `${ended}due in ${spanOf(diff)}`, overdue: false };
}
